export const includesPath = (path, target)=>{
    // 연구소 페이지 [] 텍스트로 인해 수정
    const escapedTarget = target.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
    // return !!new RegExp(`^${target}`).exec(path)
    return !!new RegExp("^".concat(escapedTarget)).exec(path);
};
export const toQueryString = function(obj) {
    let withQuerySymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (obj === null) {
        return "";
    }
    const query = Object.keys(obj).filter((key)=>key !== "" && obj[key] !== undefined && obj[key] !== "").map((key)=>"".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key]))).join("&");
    if (!query) {
        return "";
    }
    return withQuerySymbol ? "?".concat(query) : query;
};
export const getUrlStringToParams = (url)=>{
    const params = {};
    const urlSplit = url.split("?");
    if (urlSplit.length > 1) {
        const paramsSplit = urlSplit[1].split("&");
        paramsSplit.forEach((param)=>{
            const paramSplit = param.split("=");
            params[paramSplit[0]] = paramSplit[1];
        });
    }
    return params;
};
// 미설정·파싱 실패 시 사용할 기본 host (prod 도메인).
const DEFAULT_APP_HOST = "solvook.com";
/**
 * 이 마켓 앱 자신의 host 를 반환 (`NEXT_PUBLIC_APP_ENDPOINT` 기준).
 * prod=`solvook.com`, staging=`staging.solvook.com`. 미설정·파싱 실패 시 `solvook.com` 폴백.
 */ const getAppHost = ()=>{
    const endpoint = process.env.NEXT_PUBLIC_APP_ENDPOINT;
    if (!endpoint) return DEFAULT_APP_HOST;
    try {
        return new URL(endpoint).hostname.replace(/^www\./, "").toLowerCase();
    } catch (e) {
        return DEFAULT_APP_HOST;
    }
};
/**
 * 서버에서 받은 URL이 이 마켓 앱과 같은 host 면 path 만 추출해 반환, 외부면 null.
 * 내부 판정 기준은 `getAppHost()` (= 현재 앱 host, 환경별로 prod=`solvook.com`, staging=`staging.solvook.com`).
 * BE 정책상 항상 `https://` full URL 로 전달되는 것을 전제로 한다.
 * 아래 예시는 prod(`solvook.com`) 기준이며, staging 등에서는 해당 환경 host 와 비교한다.
 * - 내부(현재 앱 host, 예: `https://solvook.com/foo`, `https://www.solvook.com/foo`)면 path 반환
 * - 형제 서브도메인(`https://expert.solvook.com/foo` 등)은 별개 앱이므로 외부 취급 → null
 * - path-only(`/foo`)는 BE 정책 위반이지만 안전망으로 그대로 통과
 * - protocol-less(`www.solvook.com/foo`)도 BE 정책 위반 안전망으로 `https://` 보강 후 판별
 * - 외부(`https://other.com/foo`)면 null
 */ export const toInternalPath = (url)=>{
    if (!url) return null;
    // protocol-relative URL (`//host/path`) 은 open redirect 위험으로 외부 취급.
    if (url.startsWith("//")) return null;
    if (url.startsWith("/")) return url;
    const normalized = /^https?:\/\//i.test(url) ? url : "https://".concat(url);
    try {
        const { hostname , pathname , search , hash  } = new URL(normalized);
        const host = hostname.replace(/^www\./, "").toLowerCase();
        // 형제 서브도메인은 SPA 이동 시 현재 origin 으로 잘못 라우팅되므로 host 정확 일치만 내부로 판정.
        if (host === getAppHost()) {
            return pathname + search + hash;
        }
        return null;
    } catch (e) {
        return null;
    }
};
/**
 * 외부 URL 이동 시 사용할 정규화 함수.
 * BE 정책 위반 폴백: protocol 누락 시 `https://` 보강하여 상대 경로로 잘못 해석되는 것을 방지.
 * - 이미 절대 URL (`http://`, `https://`) 이면 그대로 반환
 * - protocol-relative (`//host`) 면 `https:` 보강
 * - path-only (`/foo`) 는 그대로 반환 (내부 경로로 취급되어 외부 fallback 으로는 오지 않으나 안전망)
 * - 그 외 (`www.other.com/foo`) 는 `https://` 보강
 */ export const normalizeExternalUrl = (url)=>{
    if (!url) return url;
    if (/^https?:\/\//i.test(url)) return url;
    if (url.startsWith("//")) return "https:".concat(url);
    if (url.startsWith("/")) return url;
    return "https://".concat(url);
};
